export enum FeeWaiversTableColumnEnum {
    Fee_WAIVER_NAME = 1,
    CREATED_BY,
    DATE_CREATED,
    NUMBER_OF_GROUPS_WITH_THE_TAG,
    NUMBER_OF_GROUPS_WITH_THE_TAG_ACTIVE,
    ACTIONS,
}

export const feeWaiversTableColumnText: { [key in FeeWaiversTableColumnEnum]: string } = {
    [FeeWaiversTableColumnEnum.Fee_WAIVER_NAME]: 'Fee Waiver Name',
    [FeeWaiversTableColumnEnum.CREATED_BY]: 'Created By',
    [FeeWaiversTableColumnEnum.DATE_CREATED]: 'Date Created',
    [FeeWaiversTableColumnEnum.NUMBER_OF_GROUPS_WITH_THE_TAG]: 'Total Groups',
    [FeeWaiversTableColumnEnum.NUMBER_OF_GROUPS_WITH_THE_TAG_ACTIVE]: 'Active Groups',
    [FeeWaiversTableColumnEnum.ACTIONS]: 'Actions',
};
